import { PostgrestSingleResponse } from '@supabase/supabase-js';

import { supabase } from './supabase';

export interface Team {
  id: string;
  name: string;
  work_hours_start: string;
  work_hours_end: string;
  check_in_times: string[];
  team_members: string[];
}

export async function fetchTeamById(teamId: string): Promise<Team> {
  const { data, error }: PostgrestSingleResponse<Team> = await supabase
    .from('teams')
    .select('*')
    .eq('id', teamId)
    .single();

  if (error) {
    throw new Error(`Failed to fetch team: ${error.message}`);
  }

  if (!data) {
    throw new Error('Team not found');
  }

  return data;
}
